import apiClient from '@src/api/clients';

const BASE_URL = 'client-inbox/email-messages/';

const cleanParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) => value !== undefined && value !== null && value !== ''
    ),
  );

export const listEmailMessages = (params = {}) =>
  apiClient.request({ url: BASE_URL, method: 'GET', payload: cleanParams(params) });

export const retrieveEmailMessage = (id, params = {}) =>
  apiClient.request({ url: `${BASE_URL}${id}/`, method: 'GET', payload: cleanParams(params) });

export const updateEmailMessage = (id, payload) =>
  apiClient.request({ url: `${BASE_URL}${id}/`, method: 'PATCH', payload });

export const listEmailSenders = () =>
  apiClient.request({ url: `${BASE_URL}senders/`, method: 'GET' });

export const triggerIngest = () =>
  apiClient.request({ url: `${BASE_URL}ingest/`, method: 'POST', payload: {} });

export const replyToEmailMessage = (id, payload) =>
  apiClient.request({ url: `${BASE_URL}${id}/reply/`, method: 'POST', payload });

export const createBudgetConfirmations = (payload) =>
  apiClient.request({ url: `${BASE_URL}budget-confirmations/`, method: 'POST', payload });

export const inspectEmailThreadContext = (id, params = {}) =>
  apiClient.request({
    url: `${BASE_URL}${id}/inspect-context/`,
    method: 'GET',
    payload: cleanParams(params),
  });

export const regenerateEmailThreadDraft = (id, payload = {}) =>
  apiClient.request({
    url: `${BASE_URL}${id}/regenerate-draft/`,
    method: 'POST',
    payload,
  });

export const getDashboardSummary = (params = {}) =>
  apiClient.request({ url: `${BASE_URL}dashboard-summary/`, method: 'GET', payload: cleanParams(params) });

export const updateConversationStatus = (id, payload) =>
  apiClient.request({ url: `${BASE_URL}${id}/update-status/`, method: 'POST', payload });

export const markThreadRead = (id) =>
  apiClient.request({ url: `${BASE_URL}${id}/mark-read/`, method: 'POST', payload: {} });

export const claimThread = (id) =>
  apiClient.request({ url: `${BASE_URL}${id}/claim/`, method: 'POST', payload: {} });

export const forwardThread = (id, payload) =>
  apiClient.request({ url: `${BASE_URL}${id}/forward/`, method: 'POST', payload });

export const listThreadNotes = (id) =>
  apiClient.request({ url: `${BASE_URL}${id}/notes/`, method: 'GET' });

export const createThreadNote = (id, payload) =>
  apiClient.request({ url: `${BASE_URL}${id}/notes/`, method: 'POST', payload });

export const bulkAction = (payload) =>
  apiClient.request({ url: `${BASE_URL}bulk-actions/`, method: 'POST', payload });

export const composeEmail = (payload) =>
  apiClient.request({ url: `${BASE_URL}compose/`, method: 'POST', payload });

const PROPOSALS_URL = 'client-inbox/knowledge-proposals/';

export const listKnowledgeProposals = (params = {}) =>
  apiClient.request({ url: PROPOSALS_URL, method: 'GET', payload: cleanParams(params) });

export const approveProposal = (id) =>
  apiClient.request({ url: `${PROPOSALS_URL}${id}/approve/`, method: 'POST', payload: {} });

export const dismissProposal = (id) =>
  apiClient.request({ url: `${PROPOSALS_URL}${id}/dismiss/`, method: 'POST', payload: {} });

const CHAT_URL = 'client-inbox/conversation-turns/';
const SESSIONS_URL = 'client-inbox/chat-sessions/';

export const sendChatMessage = (payload) =>
  apiClient.request({ url: `${CHAT_URL}chat/`, method: 'POST', payload });

export const getChatHistory = (params = {}) =>
  apiClient.request({ url: `${CHAT_URL}history/`, method: 'GET', payload: cleanParams(params) });

export const listChatSessions = (params = {}) =>
  apiClient.request({ url: SESSIONS_URL, method: 'GET', payload: cleanParams(params) });

export const createChatSession = (payload) =>
  apiClient.request({ url: SESSIONS_URL, method: 'POST', payload });

export const closeChatSession = (id) =>
  apiClient.request({ url: `${SESSIONS_URL}${id}/close/`, method: 'POST', payload: {} });

export default {
  listEmailMessages,
  retrieveEmailMessage,
  updateEmailMessage,
  listEmailSenders,
  replyToEmailMessage,
  createBudgetConfirmations,
  inspectEmailThreadContext,
  regenerateEmailThreadDraft,
  getDashboardSummary,
  updateConversationStatus,
  markThreadRead,
  claimThread,
  forwardThread,
  listThreadNotes,
  createThreadNote,
  bulkAction,
  composeEmail,
  listKnowledgeProposals,
  approveProposal,
  dismissProposal,
  sendChatMessage,
  getChatHistory,
  listChatSessions,
  createChatSession,
  closeChatSession,
};
